import React from "react";
import Navbar from "../components/Navbar";
import Flights from "../components/Flights";

const Home = () => {
  return (
    <>
      <Navbar />
      <Flights />
    </>
  );
};

export default Home;
